import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MeatGrinder = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M.565 10.261a.333.333 0 0 0 .333-.333V4.437a.333.333 0 1 0-.666 0v5.491c0 .184.149.333.333.333zM3.934 14.61h11.835V6.873a2.493 2.493 0 0 0-2.493-2.493H7.019v4.035a1.826 1.826 0 0 1-1.826 1.826H3.934v4.369zm.666-.666v-3.035h.592a2.493 2.493 0 0 0 2.493-2.493V5.047h5.59c1.009 0 1.826.818 1.826 1.826v7.071H4.599z" />
      <path d="M5.193 16a.333.333 0 0 0 .333-.333v-1.388a.333.333 0 1 0-.666 0v1.388c0 .184.149.333.333.333zM14.51 16a.333.333 0 0 0 .333-.333v-1.388a.333.333 0 1 0-.666 0v1.388c0 .184.149.333.333.333zM11.4 11.501a1.26 1.26 0 1 0 2.519 0 1.26 1.26 0 0 0-2.519 0zm1.259.592a.592.592 0 1 1 0-1.184.592.592 0 0 1 0 1.184zM.231 5.64c0 .184.149.333.333.333h6.787a.333.333 0 1 0 0-.666H.564a.333.333 0 0 0-.333.333zM.231 8.725c0 .184.149.333.333.333h6.787a.333.333 0 1 0 0-.666H.564a.333.333 0 0 0-.333.333zM.231 1.259A1.26 1.26 0 0 0 1.49 2.518h8.361a1.26 1.26 0 0 0 1.259-1.259V0H.231v1.259zm1.259.592a.592.592 0 0 1-.592-.592V.667h9.545v.592a.592.592 0 0 1-.592.592H1.49z" />
      <path d="M3.033 5.974a.333.333 0 0 0 .333-.333V2.186a.333.333 0 1 0-.666 0v3.455c0 .184.149.333.333.333zM5.501 5.974a.333.333 0 0 0 .333-.333V2.186a.333.333 0 1 0-.666 0v3.455c0 .184.149.333.333.333z" />
    </svg>
  );
};

MeatGrinder.category = 'product-category';

MeatGrinder.displayName = 'MeatGrinder';
